import React from 'react'
import { useTranslation } from 'react-i18next'

import EmptySearchImage from '@/public/images/empty-search.svg'

interface EmptySearchResultProps {
  translationKey: string
  showImage?: boolean
  className?: string
}

export const EmptySearchResult: React.FC<EmptySearchResultProps> = ({
  translationKey,
  showImage = true,
  className = '',
}) => {
  const { t } = useTranslation()

  return (
    <div className={className}>
      {showImage && (
        <img src={EmptySearchImage} alt="No search results" className="mb-4" />
      )}
      <div className="flex flex-col">
        <h3 className="p-0 m-0 font-semibold text-primary-900 text-md">
          {t(`${translationKey}.noSearchResults.title`)}
        </h3>
      </div>
    </div>
  )
}
